import { Controller } from "@hotwired/stimulus"

// Il modulo «Evento da registrare» (components/RichiesteErogazione.js, 31a5bd1): protocollo e conferma solo per la
// presentazione, gli importi solo per riconoscimento, riduzione, incasso e storno; le parti non mostrate non si
// rendono nell'originale, qui sono nascoste e spente (un campo obbligatorio nascosto bloccherebbe l'invio senza dirlo).
//   <form data-controller="evento-form" data-action="change->evento-form#aggiorna"> <select data-evento-form-target="tipo">
//   <div data-evento-form-target="blocco" data-evento-form-valori="presentazione" hidden>
export default class extends Controller {
  static targets = ["tipo", "blocco"]

  connect() {
    this.aggiorna()
  }

  aggiorna() {
    this.bloccoTargets.forEach((blocco) => {
      const mostra = (blocco.dataset.eventoFormValori || "").split(/\s+/).includes(this.tipoTarget.value)
      blocco.hidden = !mostra
      blocco.querySelectorAll("input").forEach((campo) => { campo.disabled = !mostra })
    })
  }
}
